import { Dialog, DialogActions, DialogContent } from '@material-ui/core'
import React, { useState } from 'react'
import { ContainerInfoCard_container$key } from '../__generated__/ContainerInfoCard_container.graphql'
import Button from './Button'
import FoldersCard from './File/FoldersCard'
import { graphql } from 'babel-plugin-relay/macro'
import { ProcessDakosyXmlForTransistProcedureWizardMutation } from '../__generated__/ProcessDakosyXmlForTransistProcedureWizardMutation.graphql'
import useNiceMutation from '../mutations/useNiceMutation'
import { useSnackbar } from 'notistack'

interface Props {
  slug: string
  open: boolean
  container: ContainerInfoCard_container$key
  onClose: () => void
}

const DOCUMENT_NAME_STEP_1 = 'transit-procedure'

const ProcessDakosyXmlForTransistProcedureWizard: React.FC<Props> = ({ slug, container: data, open, onClose }) => {
  const [commit] = useNiceMutation<ProcessDakosyXmlForTransistProcedureWizardMutation>(mutation)
  const [mutationError, setMutationError] = useState<null | string>(null)
  const handleDialogClose = () => {
    setSelectedSlug('')
    onClose()
  }
  const { enqueueSnackbar } = useSnackbar()
  const [selectedSlug, setSelectedSlug] = useState<string>('')

  const handleAttachmentSelect = (slug: string) => {
    if (slug === selectedSlug) {
      setSelectedSlug('')
    } else {
      setSelectedSlug(slug)
    }
  }

  const handleSubmit = () => {
    commit({
      variables: {
        input: {
          slug: selectedSlug,
          entitySlug: slug,
        },
      },
      onCompleted: (res, errors) => {
        if (errors) {
          setSelectedSlug('')
          setMutationError(errors.map((err) => err.message).join(', '))
          enqueueSnackbar(mutationError, { variant: 'error' })
        } else {
          console.log(res, 'response')
          enqueueSnackbar(res.infoProcessDakosyXmlForTransistProcedure?.message, { variant: 'success' })
          setSelectedSlug('')
          onClose()
        }
      },
    })
  }

  return (
    <>
      <Dialog open={open} maxWidth='md' onClose={handleDialogClose} scroll='paper' style={{ margin: 'auto' }}>
        <DialogContent>
          <FoldersCard
            key='documents'
            folderType='documents'
            // @ts-ignore
            folders={data.folders}
            title='Documents'
            entityType='containers'
            entitySlug={slug}
            documentType={DOCUMENT_NAME_STEP_1}
            onSelect={handleAttachmentSelect}
            selectedSlug={selectedSlug}
          />
        </DialogContent>
        <DialogActions>
          <Button variant='contained' onClick={handleSubmit} disabled={!selectedSlug}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

const mutation = graphql`
  mutation ProcessDakosyXmlForTransistProcedureWizardMutation($input: infoProcessDakosyXmlForTransistProcedureInput!) {
    infoProcessDakosyXmlForTransistProcedure(input: $input) {
      clientMutationId
      message
    }
  }
`

export default ProcessDakosyXmlForTransistProcedureWizard
